import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const getFlowTriggers = async (domain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: 'flow-triggers',
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        isEncrypted: false,
        domain,
    });
}